import { IconButton } from "@mui/material";
import ArticleSharpIcon from "@mui/icons-material/ArticleSharp";
import NoteAddSharpIcon from "@mui/icons-material/NoteAddSharp";
import { useContext, useMemo } from "react";
import { SnackbarContext } from "components/context/SnackbarProvider";
import { UserContext } from "components/context/UserProvider";
import { useActionAsNote, useResetAction } from "models/actions/apiAction";
import { useModal } from "@ebay/nice-modal-react";

const EventNoteButton = ({ event, ...props }) => {
  const { displayError } = useContext(SnackbarContext);
  const { user } = useContext(UserContext);
  const resetAction = useResetAction();
  const { mutateAsync } = useActionAsNote();
  const noteModal = useModal("NoteDrawer");

  const sameUser = useMemo(() => {
    return event.account.user.id == user.id;
  }, [event, user]);

  const openTheRightForm = (event) => {
    if (event.note_id)
      noteModal
        .show({
          formType: "update",
          id: event.note_id,
        })
        .then(resetAction);
    else if (!event.note_id && sameUser) {
      mutateAsync(event.id)
        .then((response) => {
          noteModal
            .show({
              formType: "update",
              id: response.id,
              mode: "update",
            })
            .then(resetAction);
        })
        .catch((error) => {
          displayError("Can't create note." + error);
        });
    } else {
      displayError("You can't create a note for this event.");
    }
  };

  return (
    <>
      {event.note_id && (
        <IconButton onClick={() => openTheRightForm(event)} {...props}>
          <ArticleSharpIcon />
        </IconButton>
      )}
      {!event.note_id && sameUser && (
        <IconButton onClick={() => openTheRightForm(event)} {...props}>
          <NoteAddSharpIcon />
        </IconButton>
      )}
    </>
  );
};

export default EventNoteButton;
